export const getPrice = state => state.getIn(['cimb', 'price']);
export const getBetDelay = state => state.getIn(['cimb', 'betDelay']);
export const isRequestPending = state => state.getIn(['cimb', 'requestIsPending']);
